<template>
  <div class="fs14">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="集体征文" name="first">
        <div class="">
          <!-- 征文主题 -->
          <div class=" m0 shadow-common m20">
            <div class=" bor1-e7e7eb rad10 ">
              <div class="p20 dis-f bor1-b-e7e7eb information ">
                <div class="dis-f bor5-l-FF0000 pr">
                  <p class="pannel-title">征文主题</p>
                  <div class="pl20 pa w300" style="top:-10px;left:70px;">
					  <el-select style="width: 100%"
					    v-model="solicit.Info.solicit_type.SType"
					    clearable
					    placeholder="请选择"
					  >
					    <el-option
					      v-for="item in subjectList"
					      :key="item.id"
					      :label="item.title"
					      :value="item.id"
					    >
					    </el-option>
					  </el-select>
                  </div>
                </div>
                <div class="dis-f">
                  <p class="col-gray">投稿类型</p>
                  <p class="pl20">集体投稿</p>
                </div>
              </div>
              <div class="dis-f p20 information">
                <div class="dis-f">
                  <p class="col-gray">负责人</p>
                  <p class="pl20">Miller</p>
                </div>
                <div class="dis-f">
                  <p class="col-gray">区域</p>
                  <p class="pl20">宝山区</p>
                </div>
                <div class="dis-f">
                  <p class="col-gray">征文总数</p>
                  <p class="pl20">20篇</p>
                </div>
              </div>
            </div>
          </div>
          <!-- 征文信息 -->
          <div class="bor1-efefef rad10 shadow-common m20 ">
            <div class="p20">
              <div class=" information bor5-l-FF0000 ">
                <div class="pl20 fw-b lh40 pannel-title">征文信息</div>
              </div>
            </div>
            <div class="p20 wp50 ">
              <div class="p10 ">
                <div class="dis-f">
                  <div class="col-gray w140">
                    文章名<span style="color: red" class="pl5">*</span>
                  </div>
                  <div class="wp100">
                    <p class="pl30" v-if="solicit.Info.article_title != ''">
                      {{ solicit.Info.article_title }}
                    </p>
                    <p class="fs14 col-gray pl30" v-else>上传后自动获取</p>
                  </div>
                </div>
              </div>
              <div class="p10 ">
                <div class="dis-f">
                  <div class="w140 col-gray pt10">副标题(如有)</div>
                  <el-input
                    placeholder="请输入副标题(如有)"
                    v-model="solicit.article_subtitle"
                    clearable
                  >
                  </el-input>
                </div>
              </div>
              <div class="p10 ">
                <div class="dis-f">
                  <span class="w140 col-gray pt10"
                    >联系人
                    <span class="col-ff0000">*</span>
                  </span>
                  <el-input
                    placeholder="请输入联系人"
                    v-model="solicit.Info.contact_info.contact_name"
                    clearable
                  >
                  </el-input>
                </div>
              </div>
              <div class="p10 ">
                <div class="dis-f">
                  <span class="w140 col-gray pt10"
                    >手机号
                    <span class="col-ff0000">*</span>
                  </span>
                  <el-input
                    placeholder="请输入手机号"
                    v-model="solicit.Info.contact_info.contact_phone.phone"
                    clearable
                  >
                  </el-input>
                </div>
              </div>
              <div class="p10 ">
                <div class="dis-f">
                  <span class="w140 col-gray pt10"
                    >邮箱
                    <span class="col-ff0000">*</span>
                  </span>
                  <el-input
                    placeholder="请输入邮箱"
                    v-model="solicit.Info.contact_info.contact_email"
                    clearable
                  >
                  </el-input>
                </div>
              </div>
            </div>
          </div>
          <!-- 作者信息 -->
          <div class="m20 bor1-efefef shadow-common rad10">
            <div class="p20">
              <div class=" bor5-l-FF0000 ">
                <div class="pl20 pannel-title fw-b lh40">作者信息</div>
              </div>
            </div>
            <div class="p10">
              <!-- 第一作者 -->
              <div class="p10 wp50">
                <div class="dis-f">
                  <span class="w140 pt10 col-gray">
                    第一作者姓名
                    <span class="col-ff0000">*</span>
                  </span>
                  <el-input
                    placeholder="请输入姓名"
                    v-model="solicit.AuthorList[0].author"
                    clearable
                  >
                  </el-input>
                </div>
              </div>
              <div class="dis-f">
                <div class="p10 wp50">
                  <div class="dis-f">
                    <span class="w140 pt10 col-gray"
                      >作者第一单位
                      <span class="col-ff0000">*</span>
                    </span>
                    <el-input
                      placeholder="请输入单位"
                      v-model="solicit.AuthorList[0].author_unit_1"
                      clearable
                    >
                    </el-input>
                  </div>
                </div>
                <div class="p10 wp50">
                  <div class="dis-f">
                    <span class="w140 pt10 col-gray"
                      >单位邮编
                      <span class="col-ff0000">*</span>
                    </span>
                    <el-input
                      placeholder="请输入邮编"
                      v-model="solicit.AuthorList[0].author_postcode_1"
                      clearable
                    >
                    </el-input>
                  </div>
                </div>
              </div>
              <div class="dis-f">
                <div class="p10 wp50">
                  <div class="dis-f">
                    <div class="w140 pt10 col-gray">作者第二单位</div>
                    <el-input
                      placeholder="请输入单位"
                      v-model="solicit.AuthorList[0].author_unit_2"
                      clearable
                    >
                    </el-input>
                  </div>
                </div>
                <div class="p10 wp50">
                  <div class="dis-f">
                    <div class="w140 pt10 col-gray">单位邮编</div>
                    <el-input
                      placeholder="请输入邮编"
                      v-model="solicit.AuthorList[0].author_postcode_2"
                      clearable
                    >
                    </el-input>
                  </div>
                </div>
              </div>
              <!-- 第二作者 -->
              <div class="p10 wp50">
                <div class="dis-f">
                  <div class="w140 pt10 col-gray">第二作者姓名</div>
                  <el-input
                    placeholder="请输入姓名"
                    v-model="solicit.AuthorList[1].author"
                    clearable
                  >
                  </el-input>
                </div>
              </div>
              <div class="dis-f">
                <div class="p10 wp50">
                  <div class="dis-f">
                    <div class="w140 pt10 col-gray">作者第一单位</div>
                    <el-input
                      placeholder="请输入单位"
                      v-model="solicit.AuthorList[1].author_unit_1"
                      clearable
                    >
                    </el-input>
                  </div>
                </div>
                <div class="p10 wp50">
                  <div class="dis-f">
                    <div class="w140 pt10 col-gray">单位邮编</div>
                    <el-input
                      placeholder="请输入邮编"
                      v-model="solicit.AuthorList[1].author_postcode_1"
                      clearable
                    >
                    </el-input>
                  </div>
                </div>
              </div>
              <!-- 第二作者单位 -->
              <div class="dis-f">
                <div class="p10 wp50">
                  <div class="dis-f">
                    <div class="w140 pt10 col-gray">作者第二单位</div>
                    <el-input
                      placeholder="请输入单位"
                      v-model="solicit.AuthorList[1].author_unit_2"
                      clearable
                    >
                    </el-input>
                  </div>
                </div>
                <div class="p10 wp50">
                  <div class="dis-f">
                    <div class="w140 pt10 col-gray">单位邮编</div>
                    <el-input
                      placeholder="请输入邮编"
                      v-model="solicit.AuthorList[1].author_postcode_2"
                      clearable
                    >
                    </el-input>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 上传 -->
          <div class="m20  bor1-efefef shadow-common rad10">
            <div class="p20">
              <div class="bor5-l-FF0000 ">
                <div class="pl20 fw-b pannel-title lh40">稿件附件</div>
              </div>
            </div>
            <el-upload
              class="upload-demo p10 pb20 pl40"
              ref="upload"
              action=""
              accept=".doc,.docx,.pdf"
              :before-remove="beforeRemove"
              :auto-upload="false"
              :limit="1"
              :on-exceed="handleExceed"
              :file-list="fileList"
              :on-change="getFile"
            >
              <el-button size="small" type="primary"
                ><i class="el-icon-upload pr5"></i>点击上传</el-button
              >
              <div slot="tip" class="el-upload__tip">
                附件支持DOC、DOCX格式 系统自动将附件名填为文章名
              </div>
            </el-upload>
          </div>
        </div>
        <!-- 按钮 -->
        <div class="bodys ta-c m20 ">
          <el-button
            class="btns w300 h50 lh30 ta-c p10 bor1-e7e7eb rad10"
            style="background-color: #15D8CB;"
            @click="submitForm"
          >
            <p>保存并继续添加</p>
          </el-button>
        </div>
        <!-- 表格 -->
        <div class="m20  bor1-efefef shadow-common rad10">
          <div class="p20 clearfix lh40">
            <div class="bor5-l-FF0000 fl">
              <div class="pannel-title">征文清单</div>
            </div>
            <div class="fr lh20 pr10">
              <span>征文数: 2/10篇</span>
            </div>
          </div>
          <!-- 表格 -->
          <el-table :data="essayList" class="bor1-t-e7e7eb  ">
            <el-table-column prop="ID" label="ID" width="200">
            </el-table-column>
            <el-table-column prop="article_name" label="文章名" width="400">
            </el-table-column>
            <el-table-column prop="subtitle" label="副标题(如有)" width="400">
            </el-table-column>
            <el-table-column
              prop="name"
              label="联系人"
              width="100"
            ></el-table-column>
            <el-table-column prop="enclosure" label="附件" width="400">
              <p class="sz sztianjiafujian" style="color: #007ACE;"></p>
            </el-table-column>
            <el-table-column prop="operation" label="操作" width="">
              <template slot-scope="scope">
                <el-button
                  @click="editessay(essayList)"
                  type="text"
                  class=""
                  >编辑</el-button
                >
                <el-button
                  type="text"
                  class=""
                  @click="deleteessay(essayList.ID)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-tab-pane>
      <!-- 我的征文 -->
      <el-tab-pane label="我的征文" name="second">
        <div class="m20">
          <div class="pt20 pl20 pb10">
            <div class=" bor5-l-FF0000 ">
              <div class="pl20 fw-b pannel-title lh40">征文</div>
            </div>
          </div>
          <div
            class="bor1-e7e7eb rad10 m20 p10 shadow-common"
            v-for="myEssay in list"
          >
            <div class="p10 information ">
              <div class="">{{ myEssay.add_time }}</div>
            </div>
            <div class="dis-f">
              <div class="p10">文章名</div>
              <div class="p10 pl40">
                {{ myEssay.article_title }}
              </div>
            </div>
            <div class="dis-f">
              <div class="p10">副标题(如有)</div>
              <div class="p10 pl40">
                {{ myEssay.article_subtitle }}
              </div>
            </div>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
    <!-- 编辑弹层 -->
    <my-dialog
      :title="dialogTitle"
      path="essay/edit.vue"
      ref="editessay"
      width="500px"
      yes
      @ok="afterEdit"
    ></my-dialog>
  </div>
</template>

<script>
import * as tokenUtil from "../../utils/token";
export default {
  methods: {},
  data() {
    return {
      solicit: {
		  Info: {
			subject_id: 0,
			subject_title: "",
			solicit_type: {
			  SType: 0
			},
			article_title: "",
			article_subtitle: "",
			major_author_id: 0,
			contact_info: {
			  contact_name: "",
			  contact_phone: {
				phone: ""
			  },
			  contact_email: "",
			  contact_province: {
				proviceId: 0,
				"proviceName": ""
			  },
			  "contact_city": {
				"cityId": 0,
				"cityName": "string"
			  },
			  "contact_area": {
				"areaId": 0,
				"areaName": "string"
			  },
			  "contact_address": "string",
			  "contact_postcode": "string"
			},
			"member_id": 0,
			"member_name": "string",
			"aid_region": "string",
			"review_1_mid": 0,
			"review_1_name": "string",
			"reward_1": {},
			"review_2_mid": 0,
			"review_2_name": "string",
			"reward_2": {},
			"status": {
			  "Status": 0
			},
			"reward": {},
			"add_time": "2021-12-28T05:54:59.664Z"
		  },
		  AuthorList: [
		    {
		      id: 0,
		      author: "",
		      author_unit_1: "",
		      author_unit_2: "",
		      author_postcode_1: "",
		      author_postcode_2: "",
		    },
		    {
		      id: 0,
		      author: "",
		      author_unit_1: "",
		      author_unit_2: "",
		      author_postcode_1: "",
		      author_postcode_2: "",
		    },
		  ],
		  "CurrentDoc": {
			"id": 0,
			"doc_name": "string",
			"doc_path": "string",
			"add_time": "2021-12-28T05:54:59.664Z"
		  },
		  "DocList": [
			{
			  "id": 0,
			  "doc_name": "string",
			  "doc_path": "string",
			  "add_time": "2021-12-28T05:54:59.664Z"
			}
		  ],
		  "LogList": [
			{
			  "id": 0,
			  "log_title": "string",
			  "log_type": {
				"logType": 0
			  },
			  "content": "string",
			  "solicit_status": {
				"Status": 0
			  },
			  "link": "string",
			  "operatUser": {
				"operate_id": 0,
				"operate_name": "string",
				"operate_user_type": 0
			  },
			  "add_time": "2021-12-28T05:54:59.664Z"
			}
		  ],
		  "ForeignAid": {
			"id": 0,
			"unit_name": "string",
			"member_id": {
			  "id": 0
			},
			"region": "string",
			"aid_type": {},
			"solicit_set_total": 0,
			"solicited_total": 0
		  },
		  "OperateUser": {
			"operate_id": 0,
			"operate_name": "string",
			"operate_user_type": 0
		  },
		  "DocFileName": "string",
		  "DocFile": "string"
		},
      fileList: [],
      dialogTitle: "",
      activeName: "first",
	  myInfo: {},
	subjectList: [],
      // 表格假数据
      essayList: [
        {
          ID: "1",
          article_name: "春",
          subtitle: "暖",
          name: "张三",
          enclosure: "",
          operation: "",
        },
        {
          ID: "2",
          article_name: "夏",
          subtitle: "炎",
          name: "李四",
          enclosure: "",
          operation: "",
        },
        {
          ID: "3",
          article_name: "秋",
          subtitle: "凉",
          name: "王二",
          enclosure: "",
          operation: "",
        },
        {
          ID: "4",
          article_name: "冬",
          subtitle: "冷",
          name: "陆六",
          enclosure: "",
          operation: "",
        },
      ],
      // 我的征文页面列表假数据
      list: [
        {
          id: 1,
          add_time: "2021/10/26 12:12:12",
          article_title: "关于如何讲好品德课中故事的调研报告",
          article_subtitle: "关于如何讲好品德课中故事的调研报告",
        },
      ],
    };
  },
  mounted() {
	  console.log('init');
	  this.init();
    //跳转到指定tab
    //this.showtabs();
  },
  methods: {
	init() {
		console.log('init');
		//我的投稿列表
		this.$api.essay
		  .index()
		  .then((res) => {
			console.log(res, "zhnegwen");
			this.list = res.Data.solicitListData.List;
			this.subjectList = res.Data.subjectList;
			this.solicit.Info.solicit_type.SType = this.subjectList[0].id;
		  })
		  .catch((err) => {
			this.alertError(err.Data);
		  });
		  
		  this.myInfo = tokenUtil.getInfo();
	},
    handleClick() {},
    // 打开编辑弹层
    editessay(essay) {
      this.dialogTitle = "编辑修改";
      this.$refs.editessay.show(essay);
    },
    // 删除表格记录操作
    deleteessay(essayId) {
      this.confirm("确认删除该条记录？")
        .then((_) => {
          this.essayList.some((item, i) => {
            if (item.id === essayId) {
              this.essayList.splice(i, 1);
              return true;
            }
          });
        })
        .catch((_) => {});
    },
    //表格编辑结果
    afterEdit() {},
    //跳转我征文页面
    showtabs() {
      if (this.$route.query.activeName != null) {
        this.activeName = this.$route.query.activeName;
        let current1 = this.activeName;
        if (current1 == "second") {
          this.gotolinkMyEssay(); //这里写一些跳转后必须要执行的函数
        }
      }
    },

    // 删除上传的文件
    beforeRemove(file, fileList) {
      this.$confirm(`确定移除 ${file.name}？`).then(() => {
        this.essay.DocFileName = "";
        this.essay.DocFile = "";
        this.essay.Info.article_title = "";
        this.fileList = [];
        return true;
      });
      return false;
    },

    init1(essay) {
      if (essay != undefined) {
        console.log("初始化数据", essay);
        this.essay = essay;
        this.type = `${essay.Info.cb_type.cbType}`;
        this.memberId = essay.Info.member_id;
        let fileList = [
          {
            name: essay.DocFileName,
          },
        ];
        this.fileList = fileList;

        this.chooseContact.name = essay.Info.contact_info.contact_name;
        this.chooseContact.phone = essay.Info.contact_info.contact_phone.phone;
        this.chooseContact.provice_id =
          essay.Info.contact_info.contact_province.proviceId;
        this.chooseContact.provice_name =
          essay.Info.contact_info.contact_province.proviceName;
        this.chooseContact.city_id =
          essay.Info.contact_info.contact_city.cityId;
        this.chooseContact.city_name =
          essay.Info.contact_info.contact_city.cityName;
        this.chooseContact.areas_id =
          essay.Info.contact_info.contact_area.areaId;
        this.chooseContact.areas_name =
          essay.Info.contact_info.contact_area.areaName;
        this.chooseContact.contact_info.contact_address =
          essay.Info.contact_info.contact_address || "";
        this.chooseContact.contact_info.contact_postcode =
          essay.Info.contact_info.contact_postcode;

        if (essay.AuthorList.lenth > 1) {
          this.author_two = essay.AuthorList[1].author;
          this.author_two_unit_one = essay.AuthorList[1].author_unit_1;
          this.author_two_unit_two = essay.AuthorList[1].author_unit_2;
          this.author_two_postcode_one = essay.AuthorList[1].author_postcode_1;
          this.author_two_postcode_two = essay.AuthorList[1].author_postcode_2;
        }
      } else {
        Object.assign(this.$data, this.$options.data());
      }
    },

    // 选择的文件超出限制范围
    handleExceed(files, fileList) {
      this.$message.warning(`超出文章选择上限`);
    },

    // 上传文件获取文件信息和base64加密
    getFile(file, fileList) {
      this.essay.DocFileName = file.raw.name;
      this.essay.Info.article_title = file.raw.name;
      this.getBase64(file.raw).then((res) => {
        // 这里是Base64结果
        this.essay.DocFile = res.split(",")[1];
      });
    },
    getBase64(file) {
      return new Promise(function(resolve, reject) {
        let reader = new FileReader();
        let imgResult = "";
        reader.readAsDataURL(file);
        reader.onload = function() {
          imgResult = reader.result;
        };
        reader.onerror = function(error) {
          reject(error);
        };
        reader.onloadend = function() {
          resolve(imgResult);
        };
      });
    },

    //保存提交
    submitForm() {
      if (this.essay.Info.contact_info.contact_name == "") {
        this.alertError("请填写联系人");
        return;
      } else if (this.essay.Info.contact_info.contact_phone.phone == "") {
        this.alertError("请填写手机号");
        return;
      } else if (this.essay.Info.contact_info.contact_email == "") {
        this.alertError("请填写邮箱");
        return;
      } else if (this.essay.AuthorList[0].author == "") {
        this.alertError("请填写第一作者姓名");
        return;
      } else if (this.essay.AuthorList[0].author_unit_1 == "") {
        this.alertError("请填写作者单位");
        return;
      } else if (this.essay.DocFileName == "") {
        this.alertError("请上传投稿文件");
        return;
      }

      console.log("提交的数据", this.essay);

      this.$api.essay
        .solicitSubmit(this.essay)
        .then((res) => {})
        .catch((err) => {
          this.alertError(err.Data);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.body {
  padding: 20px 200px;
}
.btns {
  padding: 40rpx;
  background: #5084f3;
  background-color: #5084f3;
  color: #fff;
  box-shadow: 0 1px 10rpx 1rpx rgba(0, 0, 0, 0.1);
}
.el-tab-pane {
  padding-top: 10px;
}

.body-l {
  width: 40%;
  border: 1px solid #efefef;
  // padding: 10px;
  margin: 40px;
}
.body-r {
  width: 40%;
  border: 1px solid #efefef;
  margin: 40px;
}
.el-input {
  width: 40%;
}

.text {
  font-size: 14px;
}

.item {
  margin-bottom: 18px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}

.box-card {
  width: 480px;
}
.pannel-title {
  height: 20px;
  line-height: 20px;
  padding-left:10px;
  font-weight: bold;
}
</style>
